<template>
  <v-flex xs3>
    <label class="v-label theme--light">{{ schema.$schema.title }}</label>

    <v-spacer></v-spacer>

    <v-layout column style="margin-top:0.5em">
      <v-card>
        <v-card-title v-if="files.length">
          <h4>Plik:</h4>
        </v-card-title>

        <v-card-title v-else class="justify-center">
          <h4>Przeciągnij plik, aby dodać</h4>
        </v-card-title>

        <v-card-text class="text-xs-center">
          <ul v-if="files.length" class="text-xs-left">
            <li v-for="file in files" :key="file.id">
              <span>{{ file.name }}</span> -
              <span>{{ file.size | formatSize }}</span>
              -
              <span v-if="file.error">błąd</span>

              <span v-else-if="file.success">wysłano</span>

              <span v-else-if="file.active">wysyłam</span>

              <span v-else></span>
            </li>
          </ul>
          <span v-else>
            <v-icon x-large>mdi-upload</v-icon>
          </span>
        </v-card-text>
      </v-card>

      <file-upload
        class="v-btn v-btn--block theme--light"
        style="padding-top:0.5em"
        v-model="files"
        ref="upload"
        :multiple="false"
        :post-action="linkPOST"
        :drop="true"
        :drop-directory="true"
        @input-file="saveToSchema"
      >
        <span>Wybierz ręcznie</span>
      </file-upload>

      <div v-if="files.length">
        <v-btn
          v-if="!$refs.upload || !$refs.upload.active"
          block
          class="primary"
          @click.prevent="$refs.upload.active = true"
          >Wyślij Plik</v-btn
        >

        <v-btn v-else block class="danger" @click.prevent="$refs.upload.active = false">
          Przerwij wysyłanie
        </v-btn>
      </div>
    </v-layout>

    <div v-show="$refs.upload && $refs.upload.dropActive" class="drop-active">
      <h3>Upuść plik</h3>
    </div>

    <p class="error--text">{{ schema.$error }}</p>
  </v-flex>
</template>

<script>
import FileUpload from 'vue-upload-component';
import { mediaResource } from '@witkac/kartamiejska-resources';

import { config } from '@/utils/config';

// @vuese
// @group Components/Forms
// Input na media
export default {
  props: {
    // schema
    schema: {
      type: Object,
      required: true
    }
  },
  components: {
    FileUpload
  },

  data() {
    return {
      files: [],
      linkPOST: config.mediaURL
    };
  },
  methods: {
    // @vuese
    // Wysyłam do schemy
    saveToSchema(newFile) {
      if (newFile.success) {
        this.schema.$schema.type === 'number'
          ? (this.schema.$model = this.files[0].response[0].id)
          : (this.schema.$model = this.files[0].response[0].id.toString());
      }
    },
    // @vuese
    // Ładowanie pliku
    loadFile() {
      if (this.schema.$model) {
        const mediaId = parseInt(this.schema.$model);

        mediaResource
          .getMedia(mediaId)
          .then(mediaInfo => {
            const file = new window.File([mediaInfo.id], mediaInfo.title, {
              type: mediaInfo.contentType
            });
            this.$refs.upload.add(file);
            this.files[0].size = mediaInfo.size;
            this.files[0].success = true;
          })
          .catch(err => this.$store.dispatch('notifyError', { title: 'Nie udało się pobrać pliku' }));
      }
    }
  },
  mounted() {
    this.loadFile();
  }
};
</script>

<style>
.drop-active {
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  position: fixed;
  z-index: 9999;
  opacity: 0.6;
  text-align: center;
  background: #000;
}
.drop-active h3 {
  margin: -0.5em 0 0;
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  font-size: 40px;
  color: #fff;
  padding: 0;
}
</style>
